export function useIdle(router) {
  const events = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel']
  let timer = null

  function onEvent() {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      console.log(router)
      if (router.currentRoute.path !== '/login') {
        sessionStorage.removeItem('hm_userData')
        router.push('/login')
      }
    }, 30 * 60 * 1_000)
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const event of events) {
    window.addEventListener(event, onEvent)
  }
}
